module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Wave")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("The second wave hits the bleak and battered shore")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("The flotsam is full of masks")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Different to the first wave before")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("We had the summer to dance and have fun")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Now reality hits like a shot from a gun")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("We jolt from our dreams")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Still stuck to our screens")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("And remember the past")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("And fear the future")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("We all knew would come")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147c337c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398433502_EPUB7.vue
// module id = 78
// module chunks = 0